// NOTE: general は汎用ツール、 specific はゲーム固有ツール
type ToolType = 'general' | 'specific';

const gtagWrapper = (...args: any[]) => {
  // @ts-ignore
  if (!window.gtag) {
    console.log('gtag: ', args);
    return;
  }

  // @ts-ignore
  window.gtag(...args);
};

const gtagWrapperEvent = (toolType: ToolType, toolName: string, game: string, eventType: string, params: object) => {
  // NOTE: 個別ツールで名前が被ってしまうと別のツールが同じ game_tool_name で計測されてしまい game_tool_name を使った分析が出来なくなってしまうので、specific(個別ツール) の場合には toolName に game をプレフィックスとして付与している
  // 逆に general(汎用ツール) の場合には game が違っても同じ toolName というツールなので toolName に game を付与せずに同じ game_tool_name で計測する
  // 具体的に言うとゲームX, ゲームY それぞれで simulator というツールが作成された場合に、は X_simulator, Y_simulator という game_tool_name で計測されるようにしている
  const correctedToolName = toolType === 'specific' ? `${game}_${toolName}` : toolName;
  const customParams = {
    gametool_tool_type: toolType,
    gametool_name: correctedToolName,
    gametool_game: game,
    gametool_event_type: eventType,
    ...params,
  };

  gtagWrapper('event', `game-tool.${eventType}`, customParams);
};

export const gtagGameToolEventPv = (toolType: ToolType, toolName: string, game: string) => {
  gtagWrapperEvent(toolType, toolName, game, 'pv_v1', {});
};
